import api from '../api/axios';

export type DeletedImage = {
  id: string;
  title: string;
  imageUrl: string;
  thumbnailUrl: string | null;
  upscaledImageUrl?: string | null;
  createdAt: string;
};

export type DeletedImagesListResponse = {
  items: DeletedImage[];
  total: number;
  page: number;
  pageSize: number;
};

const BASE = process.env.REACT_APP_BASE_API_URL || process.env.REACT_APP_API_URL || '/api';
const withBase = (path: string) => `${BASE}${path}`;

export async function listDeletedImages(params: { search?: string; page?: number; pageSize?: number }) {
  const res = await api.get(withBase('/deleted-images'), { params });
  return res.data as DeletedImagesListResponse;
}

export async function deleteDeletedImage(id: string) {
  const res = await api.delete(withBase(`/deleted-images/${id}`));
  return res.data as { deleted: boolean };
}
